import React from 'react';

export * as routes from './routes';

export default React.lazy(() => import('./KnowledgeBase'));